import React from 'react';
import cx from 'classnames';
import NotificationContainer from '../NotificationContainer';
import StackedNotificationsContainer from '../StackedNotificationsContainer';
import './index.scss';

interface IPageProps {
  className?: string | undefined;
  persona?: string | null;
  dataAutoTestId?: string;
  noPadding?: boolean;
}

const Page: React.FC<React.PropsWithChildren<IPageProps>> = (props) => (
  <div className={cx('Payments-Page', props.className)} data-auto-test-id={props.dataAutoTestId}>
    {props.persona && <NotificationContainer persona={props.persona} />}
    {props.persona && <StackedNotificationsContainer persona={props.persona} />}
    {props.children}
  </div>
);

Page.defaultProps = {
  className: undefined,
  persona: null,
};

export default Page;
